import React from 'react';
import PropTypes from 'prop-types';
import Layout from '../layouts/Layout';
import Header from '../modules/Header';
import Footer from '../modules/Footer';
import EmptySpace from '../modules/EmptySpace';
import EmailSignature from './EmailSignature';
import { PRIMARY_COLOR, GRAY_BG_COLOR } from '../../../constants';

//Style
import { body, fontWeightBold, marginBottom } from '../../../helpers/getEmailStyles';

class ContactEmail extends React.Component {

    static propTypes = {
        content: PropTypes.shape({
            ContactMessage: PropTypes.string.isRequired,
            email: PropTypes.string.isRequired,
            name: PropTypes.string.isRequired,
            phoneNumber: PropTypes.any.isRequired,
        })
    };

    render() {
        const { content: { ContactMessage, email, name, phoneNumber, logo, siteName } } = this.props;

        return (
            <Layout>
                <Header color={PRIMARY_COLOR} backgroundColor={GRAY_BG_COLOR} logo={logo} siteName={siteName} />
                <div style={body}>
                    <div style={fontWeightBold}>
                        Bonjour Admin,
                    </div>
                    <EmptySpace height={20} />
                    <div>
                        Vous avez reçu un nouveau message du support client.
                    </div>
                    <EmptySpace height={20} />
                    <div style={marginBottom}><span style={fontWeightBold}>Détails du message :</span></div>
                    <div style={marginBottom}><span style={fontWeightBold}>Nom :</span> {name}</div>
                    <div style={marginBottom}><span style={fontWeightBold}>E-mail :</span> {email}</div>
                    <div style={marginBottom}><span style={fontWeightBold}>Numéro de téléphone :</span> {phoneNumber}</div>
                    <div style={marginBottom}><span style={fontWeightBold}>Message :</span></div>
                    <div>
                        {
                            ContactMessage && (ContactMessage.trim()).split("\n").map(function (item, index) {
                                return (
                                    <span key={index}>{item}</span>
                                )
                            })
                        }
                    </div>
                    <EmptySpace height={30} />
                    <div>
                        Veuillez examiner et prendre les mesures nécessaires.
                    </div>
                    <EmptySpace height={20} />
                    <EmailSignature siteName={siteName} />
                </div>
                <EmptySpace height={40} />
                <Footer siteName={siteName} />
                <EmptySpace height={20} />
            </Layout>
        );
    }
}

export default ContactEmail;